// src/App.js
import React from "react";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import RestaurantSuggestions from "./pages/RestaurantSuggestions";
import RouteSuggestions from "./pages/RouteSuggestions";
import RestaurantMenu from "./pages/RestaurantMenu";
import Header from "./components/Header";
import Cart from "./pages/Cart";
import Verify from "./pages/Verify";
import Checkout from "./pages/Checkout";
import OfferBenefits from "./pages/OfferBenefits";
import DestinationPicker from "./pages/DestinationPicker";
import WelcomeWalkinCustomer from "./pages/WelcomeWalkinCustomer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import Locate from "./pages/Locate";
import {CartProvider} from "./context/CartContext";
import Payment from './pages/Payment';
import RateOrder from './pages/RateOrder';
import RateRestaurant from './pages/RateRestaurant';
import OrderSummary from "./pages/OrderSummary";
import OrderConfirmation from "./pages/OrderConfirmation";
import CheckoutBlocked from "./pages/CheckoutBlocked";
import TrackBus from "./pages/TrackBus";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return ( 
      <div className="w-full h-screen flex justify-center bg-[#A17V25]">
        <Router>
          <CartProvider>
            <ToastContainer />
            <Header/>
            <div className="w-full h-screen lg:w-[70%] pt-4">
            <Routes>
              <Route path="/" element={<DestinationPicker />} />
              <Route path="/suggestions" element={<RestaurantSuggestions />} />
              <Route path="/suggest-restaurant" element={<RestaurantSuggestions />} />
              <Route path="/suggest-restaurant/:citySlug" element={<RestaurantSuggestions />} />
              <Route path="/route-suggestions" element={<RouteSuggestions />} />
              <Route path="/menu-items/:restaurantId" element={<RestaurantMenu />}/>
              <Route path='/cart' element={<Cart/>}/>
              <Route path='/verify' element={<Verify/>}/>
              <Route path='/checkout' element={<Checkout/>}/>
              <Route path='/checkout-blocked' element={<CheckoutBlocked />}/>
              <Route path='/offer-benefits' element={<OfferBenefits/>}/>
              <Route path="/customer/walkin/:roadId/:restaurantId" element={<WelcomeWalkinCustomer />}/>
              <Route path="/locate" element={<Locate />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms-of-service" element={<TermsOfService />} />
              <Route path="/payment" element={<Payment />} />
              <Route path="/order-confirmation/:orderId" element={<OrderConfirmation />} />
              <Route path="/order-summary/:orderId" element={<OrderSummary />} />
              {/* Backward-compatible alias */}
              <Route path="/payment-summary/:orderId" element={<OrderSummary />} />
              <Route path="/rate/order/:positionGeohash/:restaurantId/:orderId" element={<RateOrder />} />
              <Route path="/rate/restaurant/:positionGeohash/:restaurantId" element={<RateRestaurant />} />
              <Route path="/track-bus" element={<TrackBus />} />
            </Routes>
            </div>
          </CartProvider>
        </Router>
      </div>
  );
}

export default App;
